import { render, staticRenderFns } from "./InfoModalDisplayObject.vue?vue&type=template&id=3f61f716&scoped=true&"
import script from "./InfoModalDisplayObject.vue?vue&type=script&lang=js&"
export * from "./InfoModalDisplayObject.vue?vue&type=script&lang=js&"
import style0 from "./InfoModalDisplayObject.vue?vue&type=style&index=0&id=3f61f716&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f61f716",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VDialog,VRow,VSpacer})
